import { useEffect, useMemo, useState } from "react";
import { ReactComponent as Verification } from "../../assets/svg/Verfied.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  useLazyGetLoginTokenQuery,
  useGetClinicDetailsQuery,
} from "../../services/rtkQueryServices/authenticationService";
import { useAuth } from "../../context/AuthProvider";
import { LOGIN_LITERALS } from "../../constants/literals";
import { routePaths } from "../../constants/routePaths";
import { dataStore } from "../../constants/dataStore";
import { UserService } from "../../services/UserService";

export const RegistrationSuccess = (props: any) => {
  const [searchParams] = useSearchParams();
  const subscriptionId = searchParams.get("sub_id");
  const [redirectTime, setRedirectTime] = useState<any>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const clinicDetails = useGetClinicDetailsQuery({});
  const [getLoginToken] = useLazyGetLoginTokenQuery();
  const auth = useAuth();
  const clinicInformation = useMemo(() => {
    if (clinicDetails.isSuccess && !clinicDetails.isFetching) {
      getLoginToken({}).then((res) => {
        if (res.isSuccess) {
          setRedirectTime(Number(process.env.REACT_APP_REDIRECT_TIME) || 10);
          setIsLoggedIn(true);
          UserService.isLoggedIn = "true";
          UserService.subscriptionId = subscriptionId;
          sessionStorage.removeItem(dataStore.currentStep);
        } else if (res.isError) {
          setErrorMessage(
            (res.error as any)?.data?.message ||
              LOGIN_LITERALS.somethingWentWrong
          );
        }
      });
      return clinicDetails.data.data;
    }
  }, [clinicDetails]);
  const navigate = useNavigate();
  useEffect(() => {
    const interval = setInterval(() => {
      if (redirectTime !== null && redirectTime > 0) {
        setRedirectTime(redirectTime - 1);
      } else if (redirectTime === 0) {
        auth?.logIn();
        navigate(routePaths.clinicManagement);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [redirectTime]);
  return (
    <div className="register-form-container d-flex flex-column h-100 d-flex flex-column justify-content-center">
      {clinicInformation && (
        <div className="register-header text-align-center">
          Account created successfully
        </div>
      )}
      <div className="register-clinic d-flex flex-column align-items-center">
        <Verification />
        {clinicInformation ? (
          <span className="pt-4 registration-success">{`Now you are connected to Inca Evo`}</span>
        ) : (
          <span className="pt-4 register-header text-align-center">
            Account created successfully
          </span>
        )}
        {clinicInformation && (
          <>
            <div className="pt-4 d-flex align-self-start clinic-details">
              <span className="clinic-details-header">Clinic: </span>
              <span className="px-2">{clinicInformation?.clinicName}</span>
            </div>
            <div className="pt-2 d-flex align-self-start clinic-details">
              <span className="clinic-details-header">Clinic Address:</span>
              <span className="px-2">{clinicInformation?.clinicAddress}</span>
            </div>
          </>
        )}
        <div className="text-align-center login-redirection">
          {redirectTime > 0 && (
            <div>{`You’ll be redirected to clinic management page in ${redirectTime} seconds...`}</div>
          )}
          {isLoggedIn && (
            <div>
              If you are not redirected,{" "}
              <a
                href={routePaths.clinicManagement}
                onClick={() => {
                  auth?.logIn();
                }}
              >
                click here
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
